import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const tabs = [
  {
    lang: 'cURL',
    code: `curl -X POST https://api.crosspaysolutions.com/v1/charges \\
  -H "Authorization: Bearer sk_live_xxx" \\
  -H "Content-Type: application/json" \\
  -d '{
    "amount": 150000,
    "currency": "COP",
    "method": "PSE",
    "description": "Pago factura #1234",
    "customer_email": "cliente@empresa.com"
  }'`,
  },
  {
    lang: 'Python',
    code: `import crosspay

crosspay.api_key = "sk_live_xxx"

charge = crosspay.Charge.create(
    amount=150000,
    currency="COP",
    method="PSE",
    description="Pago factura #1234",
    customer_email="cliente@empresa.com"
)

print(charge.id)  # "ch_abc123"`,
  },
  {
    lang: 'Node.js',
    code: `const crosspay = require('crosspay')('sk_live_xxx');

const charge = await crosspay.charges.create({
  amount: 150000,
  currency: 'COP',
  method: 'PSE',
  description: 'Pago factura #1234',
  customer_email: 'cliente@empresa.com'
});

console.log(charge.id); // "ch_abc123"`,
  },
];

export default function CodePreview() {
  const [active, setActive] = useState(0);

  return (
    <section className="py-24 relative overflow-hidden bg-transparent">
      <div className="absolute top-1/2 right-0 w-[400px] h-[400px] bg-purple-primary/10 rounded-full blur-[120px] pointer-events-none" />

      <div className="mx-auto max-w-7xl min-w-0 px-4 sm:px-6">
        <div className="grid min-w-0 grid-cols-1 items-center gap-12 lg:grid-cols-2">
          {/* Left - Text */}
          <motion.div
            className="min-w-0"
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
          >
            <span className="text-purple-primary text-xs font-bold tracking-widest uppercase font-label">
              Plataforma SaaS · API-First
            </span>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-black font-headline tracking-tight mt-4">
              Tecnología propia. <span className="gradient-text">Código propio.</span>
            </h2>
            <p className="text-on-surface-variant text-lg mt-4 leading-relaxed">
              Software as a Service 100% personalizable. Integre recaudo, payouts y FX
              con unas pocas líneas de código. Webhooks, dashboards y SDKs listos.
            </p>
            <div className="flex flex-wrap gap-3 mt-6">
              {['PSE', 'Nequi', 'Bancolombia', 'Daviplata', 'Davivienda', 'Tarjetas', 'ACH', 'SWIFT'].map((m) => (
                <span key={m} className="text-[11px] px-3 py-1.5 rounded-full border border-outline-variant/30 text-on-surface-variant/70 font-label">
                  {m}
                </span>
              ))}
            </div>
            <motion.a
              href="https://docs.crosspaysolutions.app/resumen"
              className="inline-flex items-center gap-2 mt-8 text-accent-magenta font-bold font-headline"
              whileHover={{ x: 4 }}
              target="_blank"
              rel="noopener noreferrer"
            >
              Ver Documentación
              <span className="material-symbols-outlined text-[18px]">arrow_forward</span>
            </motion.a>
          </motion.div>

          {/* Right - Code */}
          <motion.div
            className="relative min-w-0"
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.2 }}
          >
            <div className="absolute -inset-2 bg-gradient-to-r from-purple-primary/20 to-accent-magenta/20 rounded-2xl blur-xl" />
            <div className="relative bg-[#0d0d0d] border border-outline-variant/30 rounded-2xl overflow-hidden">
              {/* Tabs */}
              <div className="flex border-b border-outline-variant/20">
                {tabs.map((t, i) => (
                  <button
                    key={t.lang}
                    onClick={() => setActive(i)}
                    className={`px-5 py-3 text-sm font-label font-medium transition-all duration-300 relative ${
                      active === i
                        ? 'text-accent-magenta'
                        : 'text-on-surface-variant/50 hover:text-on-surface-variant/80'
                    }`}
                  >
                    {t.lang}
                    {active === i && (
                      <motion.div
                        className="absolute bottom-0 left-0 right-0 h-[2px] bg-gradient-to-r from-purple-primary to-accent-magenta"
                        layoutId="activeTab"
                        transition={{ type: "spring", stiffness: 400, damping: 30 }}
                      />
                    )}
                  </button>
                ))}
              </div>

              {/* Code */}
              <div className="p-6 min-h-[280px]">
                <AnimatePresence mode="wait">
                  <motion.pre
                    key={active}
                    className="max-w-full overflow-x-auto text-[13px] font-mono leading-relaxed text-gray-300"
                    initial={{ opacity: 0, y: 8 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -8 }}
                    transition={{ duration: 0.25 }}
                  >
                    <code>{tabs[active].code}</code>
                  </motion.pre>
                </AnimatePresence>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
